import { NavButton } from "./NavButton";
import {
  Copy,
  DocumentAttachment,
  Help,
  Home,
  Logout,
  Policy,
  QuestionAnswering,
  CertificateCheck,
} from "@carbon/icons-react";
import React, { useState } from "react";
import { Modal } from "./Modal";
import { Input } from "./Input";
import { Button } from "./Button";
import { useTranslation } from "react-i18next";
import { successToast } from "../../utils/toast";
import { Barbell } from "./icons/Barbell";
import { useAuth } from "../../utils/contexts/AuthProvider";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../utils/consts/routes";

export const Navbar = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);
  const { t } = useTranslation();
  const { logout } = useAuth();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  return (
    <nav className="w-[96px] max-h-[920px] flex flex-col flex-shrink-0 items-center gap-4 pb-7">
      <div className="pt-9 min-w-fit">
        <img src="/mstile-150x150.png" alt="logo" />
      </div>
      <div className="flex flex-col justify-between h-full">
        <div className="flex flex-col items-center gap-4">
          <NavButton
            title={t("Home")}
            icon={<Home size={28} />}
            isActive={pathname === ROUTES.dashboard}
            onClick={() => navigate(ROUTES.dashboard)}
          />
          <NavButton
            title={t("Exams")}
            icon={<QuestionAnswering size={28} />}
            isActive={pathname === ROUTES.exams}
            onClick={() => navigate(ROUTES.exams)}
          />
          <NavButton
            title={t("Documents")}
            icon={<DocumentAttachment size={28} />}
            onClick={() => navigate(ROUTES.documents)}
            isActive={pathname === ROUTES.documents}
          />
          <NavButton
            title={t("Professional Training")}
            icon={<CertificateCheck size={28} />}
            isActive={pathname === ROUTES.professionalTraining}
            onClick={() => navigate(ROUTES.professionalTraining)}
          />
          <NavButton
            title={t("Practice")}
            icon={<Barbell />}
            onClick={() => navigate(ROUTES.practice)}
            isActive={pathname === ROUTES.practice}
          />
        </div>
        <div className="flex flex-col items-center gap-4">
          <div className="bg-gray-376 w-full h-[1px]" />
          <NavButton
            title={t("Legal Documents")}
            icon={<Policy size={28} />}
            onClick={() => navigate(ROUTES.legalDocuments)}
            type="secondary"
            isActive={pathname === ROUTES.legalDocuments}
          />
          <NavButton
            title={t("Support")}
            icon={<Help size={28} />}
            onClick={() => setIsModalOpen(true)}
            type="secondary"
          />
          <NavButton
            title={t("Logout")}
            icon={<Logout size={28} />}
            type="destructive"
            onClick={() => setIsLogoutModalOpen(true)}
          />
        </div>
      </div>

      <Modal
        isModalOpen={isModalOpen}
        closeModal={() => setIsModalOpen(false)}
        title={t("Support")}
        subtitle=""
        content={
          <div className="flex flex-col justify-between gap-12">
            <div className="flex flex-col gap-0">
              <p className="text-[18px] leading-[22.68px] text-gray-550 font-light">
                {t("Need help?")}
              </p>
              <p className="text-[18px] leading-[22.68px] text-gray-550 font-light">
                {t("Drop us an email and we'll get in touch with you shortly!")}
              </p>
            </div>

            <div className="flex gap-2 items-center">
              <Input
                id="email"
                type="email"
                value="egzaminy@ominimo.pl"
                onChange={() => {}}
                wrapperClassName="flex-1"
                readOnly
              />
              <Button
                leftIcon={<Copy size={24} />}
                label={t("Copy email address")}
                type="primary"
                onClick={() => {
                  setIsModalOpen(false);
                  navigator.clipboard.writeText("egzaminy@ominimo.pl");
                  successToast(t("Email copied!"));
                }}
                additionalClassName="min-w-fit"
              />
            </div>
          </div>
        }
      />
      <Modal
        isModalOpen={isLogoutModalOpen}
        closeModal={() => setIsLogoutModalOpen(false)}
        title={t("Logout")}
        subtitle={t("Are you sure you want to log out?")}
        firstButtonLabel={t("Cancel")}
        firstButtonClick={() => setIsLogoutModalOpen(false)}
        firstButtonType="tertiary"
        secondButtonLabel={t("Log out")}
        secondButtonClick={() => logout()}
      />
    </nav>
  );
};
